{
  "pt": {
    "locale_field": {
      "fallback_tooltip": "Quando nenhum texto for inserido para esta língua, este texto padrão será usado como substituto."
    }
  }
}
